import { CeruleanButton } from 'components/Button'
import styled from 'styled-components'
import { color } from 'utils/styledHelper'

export const Title = styled.h3`
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 150%;
  color: ${color('white')};
  text-align: center;
  margin: 0;
`

export const Description = styled.p`
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 150%;
  color: ${color('grey300')};
  text-align: center;
  margin: 0;

  a {
    color: ${color('blue600')};
    text-decoration: none;
  }
`

export const ImageWrapper = styled.div<{ noMarginBottom?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 1.25rem;
  position: relative;

  > svg:last-child {
    position: absolute;
    background: white;
    border-radius: 1rem;
    top: -5px;
    left: 51%;
    padding: 1px;
  }
`

export const LogoWrapper = styled(ImageWrapper)`
  img {
    box-sizing: content-box;
    background: ${color('primary')};
    padding: 1rem;
    border-radius: 3rem;
    width: 42px;
  }
`

export const Button = styled(CeruleanButton)`
  margin-top: 1.5rem;
  width: 100%;
`
